(function () {
  var dialog = document.getElementById('cart-drawer');
  if (!dialog) return;

  var sectionId = dialog.dataset.sectionId;

  function openDrawer() {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDrawer() {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function renderCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function replaceDrawerContents(sections) {
    var html = sections && sections[sectionId];
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newDialog = parsed.getElementById('cart-drawer');
    if (newDialog) {
      dialog.innerHTML = newDialog.innerHTML;
    }
  }

  function changeLine(key, quantity) {
    dialog.setAttribute('aria-busy', 'true');

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          console.error('Cart update error:', data.message, data.description);
          return;
        }
        replaceDrawerContents(data.sections);
        renderCartCount(data.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
      })
      .catch(function (error) {
        console.error('Cart update failed', error);
      })
      .finally(function () {
        dialog.removeAttribute('aria-busy');
      });
  }

  // Opens the drawer from anywhere on the page (e.g. the header cart icon).
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-drawer-toggle]');
    if (opener) {
      event.preventDefault();
      openDrawer();
    }
  });

  // Everything inside the drawer: close button, backdrop click, quantity/remove.
  // Delegated on the dialog itself (not its children) so it survives innerHTML swaps.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) {
      closeDrawer();
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    var item = event.target.closest('[data-cart-item]');
    if (!item) return;

    var key = item.getAttribute('data-line-key');
    var qtyEl = item.querySelector('[data-quantity-value]');
    var currentQty = (qtyEl && parseInt(qtyEl.textContent, 10)) || 0;

    if (event.target.closest('[data-quantity-increase]')) {
      changeLine(key, currentQty + 1);
    } else if (event.target.closest('[data-quantity-decrease]')) {
      changeLine(key, Math.max(0, currentQty - 1));
    } else if (event.target.closest('[data-cart-remove]')) {
      changeLine(key, 0);
    }
  });

  // Exposed so other sections — the PDP buy box — can add to the cart and have
  // the drawer reflect it, without duplicating the render/count logic. Kept
  // deliberately small: the drawer stays the only owner of how it renders.
  window.ryCartDrawer = {
    sectionId: sectionId,
    open: openDrawer,
    close: closeDrawer,
    apply: function (payload) {
      if (!payload) return;
      if (payload.sections) replaceDrawerContents(payload.sections);
      if (typeof payload.item_count === 'number') renderCartCount(payload.item_count);
    },
  };
})();
